<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
        <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success }}</v-alert>
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn v-if="$store.state.store_arin.user_data.status_main_store != 1" type="button" class="btn_add_data"
              elevation="4" @click="product_add_dialog()" large>เพิ่มสินค้าใหม่</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          <v-row>
            <v-col v-if="$store.state.store_arin.user_data.status_main_store != 1" xs="12" sm="12" md="3" lg="3" xl="3"
              cols="12">
              <!-- <v-select class="input-radius" :items="selectItems" label="เลือก Action สินค้าที่เลือก" single-line outlined
                dense></v-select> -->
              <v-btn v-if="selected != ''" @click="delete_all = true" outlined
                color="error"><v-icon>mdi-trash-can</v-icon> ลบรายการที่เลือก</v-btn>
              <v-btn v-else outlined color="secondary"><v-icon>mdi-trash-can</v-icon> ลบรายการที่เลือก</v-btn>
            </v-col>
            <v-col v-else></v-col>
            <v-col xs="12" sm="12" md="5" lg="5" xl="5" cols="12"></v-col>
            <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
              <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required
                v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
            <v-data-table v-if="$store.state.store_arin.user_data.status_main_store == 1" v-model="selected"
              :headers="headers" item-key="id" :items="product_list" :search="search" :footer-props="footer_Props">
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <!-- <td class="hidden_line">
                      <v-checkbox v-if="$store.state.store_arin.user_data.status_main_store == 1" color="#D6BFAF" v-model="selected" :value="item" disabled/>
                      <v-checkbox v-else color="#D6BFAF" v-model="selected" :value="item" />
                    </td> -->
                    <td class="hidden_line">
                      <div>{{ item.product_code }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ item.name }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ item.name_sci }}</div>
                    </td>
                    <td class="hidden_line">
                      <div class="d-flex justify-center">
                        <v-switch color="success" v-model="item.status" @click="status_product(item.id)" inset></v-switch>
                      </div>
                    </td>
                    <td class="hidden_line">
                      <v-btn elevation="4" class="ma-2" @click="detail_product(item.id)" outlined color="#8EBBDC"
                        height="45" small title="ดูรายละเอียด" style="border-radius:10px">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn v-if="item.product_pharma_status == 0" elevation="4" class="ma-2" outlined color="#FEA06C"
                        height="45" small title="แก้ไขรายละเอียด" style="border-radius:10px" disabled>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn v-if="item.product_pharma_status == 1" elevation="4" class="ma-2"
                        @click="edit_product(item.id)" outlined color="#FEA06C" height="45" small title="แก้ไขรายละเอียด"
                        style="border-radius:10px">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn type="button" elevation="4" class="ma-2" @click="delete_product(item.id);" outlined
                        height="45" small color="error" title="ลบข้อมูล" style="border-radius:10px" disabled>
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <v-data-table v-else show-select v-model="selected" :headers="headers" item-key="id" :items="product_list"
              :search="search" :footer-props="footer_Props">
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td class="hidden_line">
                      <v-checkbox v-if="$store.state.store_arin.user_data.status_main_store == 1" color="#D6BFAF"
                        v-model="selected" :value="item" disabled />
                      <v-checkbox v-else color="#D6BFAF" v-model="selected" :value="item" />
                    </td>
                    <td class="hidden_line">
                      <div>{{ item.product_code }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ item.name }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ item.name_sci }}</div>
                    </td>
                    <td class="hidden_line">
                      <div class="d-flex justify-center">
                        <v-switch color="success" v-model="item.status" @click="status_product(item.id)" inset></v-switch>
                      </div>
                    </td>
                    <td class="hidden_line">
                      <v-btn elevation="4" class="ma-2" @click="detail_product(item.id)" outlined color="#8EBBDC"
                        height="45" small title="ดูรายละเอียด" style="border-radius:10px">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <!-- <v-btn elevation="4" class="ma-2" outlined color="#FEA06C"
                        height="45" small title="แก้ไขรายละเอียด" style="border-radius:10px" disabled>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn> -->
                      <v-btn elevation="4" class="ma-2" @click="edit_product(item.id)" outlined color="#FEA06C"
                        height="45" small title="แก้ไขรายละเอียด" style="border-radius:10px">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn type="button" elevation="4" class="ma-2" @click="delete_product(item.id);" outlined
                        height="45" small color="error" title="ลบข้อมูล" style="border-radius:10px">
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog v-model="product_detail_dialog" persistent max-width="353" max-height="313">
        <v-card>

          <div class="d-flex justify-space-between">
            <v-card-title color="#616A6B">
              การเพิ่มข้อมูลสินค้า
            </v-card-title>
            <v-btn icon class="ma-4" @click="product_detail_dialog = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="text-center">กรุณาเลือกการเพิ่มข้อมูลสินค้า</div>
          <div class="title_page_space ">
            <v-card @click="confirm_redirect('/arin/pos/chooseproduct')" elevation="3" class="card_modal ma-5 mr-0 pa-3">
              <v-img height="47" max-width="47" :lazy-src="img_upload" :src="img_upload" class="preview"></v-img>
              <div class="text-center" style="color:#838383;">เลือกดึง</div>
              <div class="text-center" style="color:#838383;">ชุดข้อมูลสินค้า</div>
            </v-card>

            <v-card @click="confirm_redirect('/arin/pos/addproductdata')" elevation="3" class="card_modal ma-5 ml-0 pa-3">
              <v-img height="47" max-width="47" :lazy-src="img_package" :src="img_package" class="preview"></v-img>
              <div class="text-center" style="color:#838383;">เพิ่ม</div>
              <div class="text-center" style="color:#838383;">ข้อมูลสินค้าใหม่</div>
            </v-card>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn type="button" class="btn_confirm_data" elevation="4" large>ยืนยัน</v-btn> -->
            <v-spacer></v-spacer>
          </v-card-actions>

        </v-card>
      </v-dialog>

      <v-dialog v-model="delete_all" persistent max-width="450">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>

            </v-card-title>
            <v-btn icon class="ma-4" @click="delete_all = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img width="90" height="90" src="@/assets/arin_assets/warning.png" class="preview mt-3 mb-2"></v-img>
                  <h3>ยืนยันการลบสินค้าที่เลือกไว้</h3>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn type="button" class="btn_add_data_pop"
              style=" background: linear-gradient(90deg, #FFFF 0%, rgba(136, 179, 88, 0) 100%), #FFFF !important;"
              color="error" elevation="4" outlined @click="delete_all = false" large>ยกเลิก</v-btn>
            <v-btn type="button" class="btn_add_data_pop" elevation="4" @click="removeProduct_all()" large>ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>

<script>

import img_upload from "@/assets/arin_assets/uploading.png";
import img_package from "@/assets/arin_assets/add-package.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_warehouse_product_list",
  data() {
    return {
      loading_page: true,
      alert_success: false,
      alert_message_success: null,
      alert_message_error: null,
      search: '',
      action_id: '',
      product_detail_dialog: false,
      product_modal: false,
      img_upload: img_upload,
      img_package: img_package,
      checkbok: false,
      selectItems: ['ลบรายการที่เลือก'],
      selected: [],
      delete_all: false,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'รายการสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '120px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
          align: 'left',
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
          width: '180px',
          align: 'left',
        },
        {
          text: 'สถานะ',
          value: '',
          fixed: true,
          width: '120px',
          align: 'center',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          width: '160px',
          align: 'left',
        },
      ],
      product_list: [],
      product_detail: [],
    }
  },
  methods: {
    updateSelected() {
      alert(0)
    },
    // GET ข้อมูลสินค้า
    getProductList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/products', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          console.log(res.data.product_list);
          this.product_list = res.data.product_list;
          this.selected = []
        }
      })
    },
    confirm_redirect(link_url) {
      this.product_modal = false
      this.$router.push(link_url)
    },
    status_product(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.post('/product/updatestatus/' + id, null, config).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true
          this.alert_message_success = 'เปลี่ยนสถานะเรียบร้อยแล้ว'
          setTimeout(() => this.alert_success = false, 3000)
        }
      })
    },
    detail_product(id) {
      window.location.href = '/arin/pos/detailproductdata/' + id;
    },
    edit_product(id) {
      window.location.href = '/arin/pos/editproductdata/' + id;
    },
    delete_product(id) {
      Swal.fire({
        // title: 'คุณต้องการลบข้อมูลหรือไม่?',
        text: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          let config = {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }
          };
          HTTP_ARIN.post('/product/delproduct/' + id, {}, config).then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'ลบข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
        }
      })
    },
    async removeProduct_all() {
      const data = {
        arr_del: this.selected.map(o => o.id)
      }
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      }
      await HTTP_ARIN.post(`/product/del/multi`, data, config).then((res) => {
        if (res.data.successful === true) {
          this.getProductList()
          this.delete_all = false;
          this.alert_success = true
          this.alert_message_success = 'ลบข้อมูลที่เลือกเรียบร้อย'
          setTimeout(() => this.alert_success = false, 5000)
        }
      })
    },
    product_add_dialog() {
      this.product_detail_dialog = true;
    }
  },
  mounted() {
    this.getProductList();
  },
}
</script>

<style scoped>
.input-radius {
  border-radius: 10px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.card_modal {
  border: 1px solid #ADADAD;
  border-radius: 10px;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.mobile_btn {
  width: 30%;
}

.btn_confirm_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 50%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 200px; */
}

.btn_add_data_pop {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 135px !important;
}
</style>

